var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$isOptimize && !_vm.$isMida)?_c('Header'):_vm._e(),_vm._v(" "),_c('SettingMenu'),_vm._v(" "),_c('div',{staticClass:"page-wrapper-2"},[_c('div',{staticStyle:{"margin-top":"56px"}},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78b36a7c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/AuthMenu.vue
// module id = null
// module chunks = 